module.exports = __webpack_public_path__ + "img/service_select.a3546ed7.png";